/**
 * FuncionalidadesApiClient -- el catalogo de funcionalidades por tipo de negocio (FUNCIONES-POR-TIPO-T1, Ares #42309).
 *
 * Contrato (nexo-api PR 768, nodo tbl-funcionalidades-por-tipo; solo lectura, la regla vive en la base):
 *   GET /api/v1/tipos-negocio/funcionalidades           -> data: [{ tipo, tipoVisible, funcionalidad, grupo, nombre, activa, confirmada }]
 *   GET /api/v1/businesses/{businessId}/funcionalidades -> data: [{ funcionalidad, grupo, nombre, porTipo, ajuste, activa, fuente, confirmada, planIncluye }]
 * Mientras la API no lo sirva responde 404 y la vista lo dice (NO_PUBLICADO); se enciende sola cuando se publique.
 * Nunca lanza.
 *
 * @module infrastructure/api/FuncionalidadesApiClient
 */
import { ApiBase } from './ApiBase.js';

function motivo(res) {
  if (res?.code === 404) return 'NO_PUBLICADO';
  if (res?.code === 401 || res?.code === 403) return 'PROHIBIDO';
  if (res?.code === 'NETWORK' || res?.code === 'TIMEOUT') return 'SIN_RED';
  return 'ERROR_API';
}

async function leer(ruta) {
  let res;
  try {
    res = await ApiBase.get(ruta);
  } catch {
    return { ok: false, motivo: 'SIN_RED' };
  }
  if (!res?.ok) return { ok: false, motivo: motivo(res) };
  return { ok: true, data: res.data?.data ?? res.data ?? [] };
}

export const FuncionalidadesApiClient = {
  /** La matriz tipo x funcionalidad con sus defectos (y si estan confirmados). */
  porTipo() {
    return leer('/api/v1/tipos-negocio/funcionalidades');
  },
  /** Lo que resulta para un negocio: el ajuste del negocio si lo hay, si no el defecto de su tipo. */
  deNegocio(businessId) {
    return leer(`/api/v1/businesses/${encodeURIComponent(String(businessId ?? ''))}/funcionalidades`);
  }
};
